/** @jsx jsx */
import { useState } from 'react';
import { jsx } from 'theme-ui';
import Headroom from 'react-headroom';
import styled from '@emotion/styled';
import HeaderLogo from '../logo/headerMainLogo.jsx';
import BurgerMenuButton from './BurgerMenuButton';
import theme_v1 from '../../gatsby-plugin-theme-ui-v1/index.js';
import theme_v2 from '../../gatsby-plugin-theme-ui/index.js';

// This file only runs serverside
function generateBrandSpecificComponents (brand, region) {
  var customCTA_styles, 
    container_styles = '',
    customNavMobileMenu_styles = '',
    navMobile_styles = `
      padding: 1em 1em 1em 2em;

      #logo {
        padding-left: 10px;
      }
    `,
    customNav_styles,
    customNavMenu_styles;

  var theme;
  if(region === 'US') {
    theme = theme_v2;
    customNav_styles = `
      padding-top: 10px;

      #logo {
        padding-left: 20px;
      }
    `;

    customNavMenu_styles = `
      padding: 1em;
    `;
  } else {
    theme = theme_v1;
    customNav_styles = `
      text-transform: uppercase;
      padding: 1em 1em 1em 2em;
    `;

    customNavMenu_styles = `
      padding: 1em 1em 0.6em;
    `;
  }
  
  navMobile_styles += `height: 68px`;
  container_styles = `
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    box-shadow: rgba(0, 0, 0, 0.15) 1px 2px 6px 0px;
  `;

  const brandColors = theme.referenceColors;
  const Container = styled.header`
    background: ${brandColors.background};
    font-family: ${theme.fonts.nav};
    font-size: ${theme.styles.root.header.fontSize};
    font-weight: ${theme.fontWeights.heading};
    height: ${theme.sizes.navHeight};
    
    ${container_styles} 
  `;

  const MobileNavigationButton = styled(BurgerMenuButton)`
    @media only screen and (min-width: 881px) {
      display: none;
    }
  `;

  const Navigation = styled.nav`
    align-items: center;
    display: flex;
    margin: 0 auto;
    max-width: 1400px;
    
    .nav-content {
      width: 100%;
      display: flex;
      align-items: center;
    }
  
    ${customNav_styles}

    @media only screen and (max-width: 880px) {
      ${navMobile_styles}
    }
  `;

  const NavList = styled.div`
    margin-left: 16px;

    a {
      color: ${brandColors.navList};
      display: inline-block;
      
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }

      ${customNavMenu_styles}
    }

    @media only screen and (max-width: 880px) {
      display: none;

      &.open {
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 5px 1px rgb(0 0 0 / 25%);
        display: block;
        left: 0;
        position: absolute;
        top: 4rem;
        z-index: 999;

        a {
          display: block;
          padding: 1.4em 1.4em 1em;
        }

        ${customNavMobileMenu_styles}
      }
    }
  `;

  var HeaderCTAButton = customCTA_styles ? customCTA_styles : styled.a`
      color: ${brandColors.headerCTA};
      font-family: ${theme.fonts.nav};
      margin-left: auto;
      padding: 0.6em 1em 0.6em;

      @media only screen and (max-width: 500px) {
        padding: 0.6em 0; 
      }
    `;

  return { Container, MobileNavigationButton, Navigation, NavList, HeaderCTAButton }
}

const Header = ({ regionConfig, pageData }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { Container, MobileNavigationButton, Navigation, NavList, HeaderCTAButton } = generateBrandSpecificComponents( regionConfig.brand, regionConfig.region )
  
  var headroomStyles = {
        zIndex: 9999,
      };

  if(regionConfig.brand === 'harrys') {
    headroomStyles.boxShadow = '1px 1px 1px rgba(0,0,0,0.25)';
  }

  // Grab cta text and link from page properties if set. If not set, use region config default text and link
  var ctaText = pageData?.navCtaText? pageData.navCtaText : regionConfig.headerCTA.title, 
      ctaLink = pageData?.navCtaLink? pageData.navCtaLink : `${regionConfig.headerCTA.url}`;  

  const showNav = regionConfig.headerNavigation.length > 0 || pageData?.navMenu?.length > 0;

  return (
    <Headroom
      style={headroomStyles}
      upTolerance={0}
    >
      <Container>
        <Navigation>
          <div className="nav-content">
          {showNav &&
            <MobileNavigationButton
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
            />
          }
          <a href={`https://${regionConfig.domain}`} id="logo" style={{ 'lineHeight': 1}}>
            <HeaderLogo regionConfig={regionConfig} />
          </a>
          <NavList className={mobileNavOpen ? 'open' : 'closed'}>
            {regionConfig.headerNavigation && regionConfig.headerNavigation.map((link) => (
              <a key={link.url} href={link.url}>
                {link.title}
              </a>
            ))}
            {pageData?.navMenu && pageData?.navMenu.map((link) => (
              <a key={link.url} href={link.url}>
              {link.text}
            </a>
            ))}
          </NavList>
          
          {!pageData?.navHideCta &&
            <HeaderCTAButton id="navCTA" href={ctaLink}>
              {ctaText}
            </HeaderCTAButton>
          }
          </div>
        </Navigation>
      </Container>
    </Headroom>
  );
};

export default Header;
